import React, { Fragment, useState, useRef } from "react";
import { MuiColorInput } from 'mui-color-input'
import Loader from "../../common/Loader"
import {  CLASSNAME_P_B, CLASSNAME_P_T, CLASSNAME_M_B, CLASSNAME_M_T } from '../../constant/bannerItems'
import DeleteIcon from '@mui/icons-material/Delete';
import { List, ListItem, ListItemText, TextField, Button, FormControl, Select, MenuItem ,styled} from "@mui/material";

import TextEditorConfig from "../../helpers/TextEditor";
import JoditEditor from "jodit-react";

const StyledFormControl = styled(FormControl)({
	width: '40ch',
});

const StyledTextField = styled(TextField)({
	width: '40ch',
});



const ProductImageVideoForm = ({ productId, isLoading, handleClose, inputs, handleInputChange, handleColorPicker, handleSubmit, errors, fromEditAction, tempImage, setImageFile, deleteImage, resetColor }) => {


	const [temp, setTemp] = useState("");
	const editor = useRef(null)


	const errorClass = {
		color: "red",
	}

	const onSubmit = () => {
		handleSubmit()
	}

	return (
		<Fragment>
			{isLoading && (
				<Loader />
			)}
			<div className="banner-form" style={{ 'minHeight': '50vh' }}>
				<form className="banner-form-style" >
					<List>
						{fromEditAction === 'topBottomspace' && (
							<>
								<ListItem className="mb-35" 
										secondaryAction={
											<StyledFormControl variant="outlined" >
												<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingTop}
													onChange={handleInputChange}
													name="paddingTop">
													{CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
														return <MenuItem value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
													})}
													{!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
												</Select>
											</StyledFormControl>
										}
								
								>
									<ListItemText id="switch-list-label-wifi" primary="Padding Top" />
								</ListItem>

								<ListItem className="mb-35"
								   secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingBottom}
												onChange={handleInputChange}
												name="paddingBottom">
												{CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
								   }
								>
									<ListItemText id="switch-list-label-wifi" primary="Padding Bottom" />
								</ListItem>
								<ListItem className="mb-35"
								   	secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginTop}
												onChange={handleInputChange}
												name="marginTop">
												{CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Top" />
								</ListItem>

								<ListItem className="mb-35"
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginBottom}
												onChange={handleInputChange}
												name="marginBottom">
												{CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Bottom" />
								</ListItem>
							</>
						)}
						{fromEditAction === 'btn' && (
							<>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Buttton color" />
									<div className="col-lg-3">
										<MuiColorInput
											name="btnColor"
											format="hex"
											defaultValue="#000"
											value={inputs.btnColor}
											onChange={color => { handleColorPicker('btnColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnColor != undefined && (inputs.btnColor)}</p>
									</div>
									{inputs.btnColor != "undefined" &&
										inputs.btnColor != undefined &&
										inputs.btnColor != "" && (
											<DeleteIcon
												className="text-error  ml-4"
												title={"Reset Background color"}
												onClick={() => {
													resetColor("", 'btnColor')
												}}
												aria-label=""
											/>)}
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Buttton Text color" />
									<div className="col-lg-3">
										<MuiColorInput
											name="btnTextColor"
											format="hex"
											defaultValue="#000"
											value={inputs.btnTextColor}
											onChange={color => { handleColorPicker('btnTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnTextColor != undefined && (inputs.btnTextColor)}</p>
									</div>
									{inputs.btnTextColor != "undefined" &&
										inputs.btnTextColor != undefined &&
										inputs.btnTextColor != "" && (
											<DeleteIcon
												className="text-error  ml-4"
												title={"Reset Background color"}
												onClick={() => {
													resetColor("", 'btnTextColor')
												}}
												aria-label=""
											/>)}
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Hover color" />
									<div className="col-lg-3">
										<MuiColorInput
											name="btnHoverColor"
											format="hex"
											defaultValue="#000"
											value={inputs.btnHoverColor}
											onChange={color => { handleColorPicker('btnHoverColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnHoverColor != undefined && (inputs.btnHoverColor)}</p>
									</div>
									{inputs.btnHoverColor != "undefined" &&
										inputs.btnHoverColor != undefined &&
										inputs.btnHoverColor != "" && (
											<DeleteIcon
												className="text-error ml-4"
												title={"Reset"}
												onClick={() => {
													resetColor("", 'btnHoverColor')
												}}
												aria-label=""
											/>)}
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Hover Text Color" />
									<div className="col-lg-3">
										<MuiColorInput
											name="btnHoverTextColor"
											format="hex"
											defaultValue="#000"
											value={inputs.btnHoverTextColor}
											onChange={color => { handleColorPicker('btnHoverTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnHoverTextColor != undefined && (inputs.btnHoverTextColor)}</p>
									</div>
									{inputs.btnHoverTextColor != "undefined" &&
										inputs.btnHoverTextColor != undefined &&
										inputs.btnHoverTextColor != "" && (
											<DeleteIcon
												className="text-error ml-4"
												title={"Reset"}
												onClick={() => {
													resetColor("", 'btnHoverTextColor')
												}}
												aria-label=""
											/>)}
								</ListItem>
							</>
						)}
						{fromEditAction === 'title' && (
							<>

								<div className='row mb-35'>

									<div className='col-md-3'>

										<ListItemText id="switch-list-label-wifi" primary="Title text" />
									</div>
									<div className='col-md-9'>
										<JoditEditor
											ref={editor}
											value={inputs.title}
											config={TextEditorConfig}
											tabIndex={1}
											style={{
												width: '40ch',
											}}
											onChange={(bodyOfEditor) => {
												inputs.title = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</>
						)}


						{fromEditAction === 'description' && (
							<>
								<div className='row mb-35'>

									<div className='col-md-3'>

										<ListItemText id="switch-list-label-wifi" primary="Description" />
									</div>
									<div className='col-md-9'>
										<JoditEditor
											ref={editor}
											value={inputs.description}
											config={TextEditorConfig}
											tabIndex={1}
											style={{
												width: '40ch',
											}}
											onChange={(bodyOfEditor) => {
												inputs.description = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>



							</>
						)}
						{fromEditAction === 'image' && (
							<>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Image" />
									<div className="col-lg-5">
										<input onChange={(e) => setImageFile(e, 'image')}
											type="file"
											name="image"
										/>
									</div>

									<div className="col-lg-3"> {tempImage && (<>
										<img height="50px" width="50px" src={tempImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage('tempImage')
											}}
											aria-label=""
										/></>)}
									</div>
								</ListItem>
							</>
						)}
						{(fromEditAction === 'link' || fromEditAction == 'btn') && (
							<>
								<ListItem className="mb-35"
									secondaryAction={
										<StyledTextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											value={inputs.link}
											onChange={handleInputChange}
											name="link"
										/>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Link" />
								</ListItem>
								<ListItem className="mb-35"
									secondaryAction={
										<StyledTextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											value={inputs.linkText}
											onChange={handleInputChange}
											name="linkText"
										/>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Link Text" />
								</ListItem>
							</>
						)}
						{fromEditAction === 'video' && (
							<>
								<ListItem className="mt-55 mb-35"
									secondaryAction={
										<StyledTextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											value={inputs.videoId}
											onChange={handleInputChange}
											name="videoId"
										/>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Video Id" />
								</ListItem>
								{inputs.channel == "youtube" && (<p><b>Ex.</b>https://www.youtube.com/watch?v=<b>EngW7tLk6R8</b> </p>)}
								{inputs.channel == "vimeo" && (<p><b>Ex.</b>https://vimeo.com/<b>253989945</b> </p>)}
								<ListItem className="mt-55 mb-35"
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select
												labelId="demo-simple-select-outlined-label" value={inputs.channel}
												onChange={handleInputChange}
												name="channel">
												<MenuItem value={"youtube"}> Youtube</MenuItem>
												<MenuItem value={"vimeo"}> Vimeo</MenuItem>
												<MenuItem value={"youku"}> Youku</MenuItem>
												<MenuItem value={"custom"}> Custom</MenuItem>
											</Select>
										</StyledFormControl>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Video Channel" />
								</ListItem>
							</>
						)}

						<ListItem>
							<button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
							<Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {productId ? "Update" : "Save"}</Button>

						</ListItem>
					</List>

				</form>
			</div>
		</Fragment >
	);
};

export default ProductImageVideoForm;
